import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ServiceLocation from 'pages/serviceLocation/ServiceLocation';

const ServiceLocationRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<ServiceLocation />} />
    </Routes>
  );
};

export default ServiceLocationRouter;
